import styled from 'styled-components'

export const Kpis = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-bottom: 34px;
  border-block: 1px solid ${p => p.theme.palette.colors.borderSoft};

  @media (max-width: 1040px) { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  @media (max-width: 720px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 420px) { grid-template-columns: 1fr; }
`

export const Kpi = styled.div`
  display: grid;
  min-width: 0;
  min-height: ${p => p.primary ? '112px' : '92px'};
  align-content: center;
  gap: 9px;
  padding: ${p => p.primary ? '22px' : '18px 22px'};
  border-right: 1px solid ${p => p.theme.palette.colors.borderSoft};

  &:nth-child(4n) { border-right: 0; }
  @media (max-width: 1040px) { &:nth-child(4n) { border-right: 1px solid ${p => p.theme.palette.colors.borderSoft}; } &:nth-child(3n) { border-right: 0; } }
  @media (max-width: 720px) { &:nth-child(3n) { border-right: 1px solid ${p => p.theme.palette.colors.borderSoft}; } &:nth-child(2n) { border-right: 0; } }
  @media (max-width: 420px) { border-right: 0; }
`

export const KpiLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 7px;
  color: ${p => p.theme.palette.colors.subdued};
  font: 600 11px/1.4 Poppins, sans-serif;
  letter-spacing: 0.055em;
  text-transform: uppercase;
`

export const KpiValue = styled.strong`
  overflow: hidden;
  color: ${p => p.theme.palette.colors.text};
  font: 700 clamp(24px, 2.5vw, 36px)/1 Poppins, sans-serif;
  letter-spacing: -0.04em;
  text-overflow: ellipsis;
`

export const InfoBadge = styled.button`
  display: inline-grid;
  width: 17px;
  height: 17px;
  padding: 0;
  border: 1px solid ${p => p.theme.palette.colors.borderStrong};
  border-radius: 50%;
  background: transparent;
  place-items: center;
  color: ${p => p.theme.palette.colors.muted};
  font: 700 10px/1 Poppins, sans-serif;
  text-transform: none;
  cursor: pointer;
  transition: 0.2s ease;
  transition-property: border-color, background-color, color, transform;

  &:hover,
  &:focus-visible {
    border-color: ${p => p.theme.palette.blue.main};
    background: ${p => p.theme.palette.blue.main}1a;
    color: ${p => p.theme.palette.blue.main};
    outline: none;
    transform: translateY(-1px);
  }

  @media (prefers-reduced-motion: reduce) { transition: none; transform: none; }
`
